import { createSelector } from 'reselect';
import { getDeviceInteraction } from '@gameday/utils/selectors/getDeviceInteraction';

// selectors
const getPreviewInfo = (state) => state?.previewInfo || {};
const getPreviewTeamStandings = (state) => getPreviewInfo(state).standingsData || {};
const getPreviewTeams = (state) => getPreviewInfo(state).teams;
const getDisableTicketLink = (state) => state?.config?.disableTicketLink;

const getPreviewInfoHomeAway = (state, homeOrAway) => {
    const teams = getPreviewTeams(state) || {};
    const team = teams?.[homeOrAway] || {};
    const standingsData = getPreviewTeamStandings(state);
    const league = team?.league?.id;
    const id = team?.id;
    const standings = standingsData[league]?.[id];

    return standings;
};

const getPreviewInfoHome = (state) => getPreviewInfoHomeAway(state, 'home');
const getPreviewInfoAway = (state) => getPreviewInfoHomeAway(state, 'away');

const getLoading = (state) => state.loading?.isLoading;
const getLanguage = (state) => state.config?.language;
const getLocalTimezone = (state) => state.config?.localTimezone;

// reselect function
export const getPreviewInfoState = createSelector(
    [getPreviewInfo, getLoading, getLanguage, getPreviewInfoHome, getPreviewInfoAway, getLocalTimezone, getDisableTicketLink, getDeviceInteraction],
    (previewInfo, isLoading, language, homeStandings, awayStandings, localTimezone, disableTicketLink, deviceInteraction) => (
        {
            ...previewInfo,
            homeStandings,
            awayStandings,
            isLoading,
            language,
            localTimezone,
            disableTicketLink
        }
    )
);
